<template>
  <div class="info-panel">
    <div class="question">Question ID: {{ definition.metabase.question }}</div>

    <div v-if="definition.metabase.studyLock">Locked to Study</div>
    <div class="col-md-4" v-if="definition.metabase.parameters">
      <table class="table table-striped table-hover table-sm">
        <thead>
          <td>Parameter</td>
          <td>Value</td>
        </thead>
        <tr v-for="parameter in definition.metabase.parameters">
          <td>{{parameter.name}}</td>
          <td>{{parameter.value}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      definition: {
        type: Object
      }
    }
  }
</script>

<style scoped>
.info-panel {
  font-weight: normal;
  font-size: 16px;
}


</style>
